/*tslint:disable:no-bitwise */
import {Injectable} from '@angular/core';
declare var jQuery: any;
declare var $: any;

@Injectable()
export class UtilitiesService {
  static useTestEndpoint = false;
  public static get baseAPIUrl(): string {
    const nav: any = navigator;

    if (window.location.hostname === 'localhost' && !(window as any).isIOS && (!nav || !nav.camera)) {
      return 'http://localhost:5529/api/';
    } else if (UtilitiesService.useTestEndpoint ||
               window.location.hostname.toLowerCase().indexOf(
                   'azurewebsites.net') > -1) {
      return 'https://dev-api.oneguard.net/api/';
    } else if (window.location.hostname.toLowerCase().indexOf(
                   'homeowner.oneguardhomewarranty.com') > -1) {
      return 'https://api.oneguard.net/api/';
    }

    return 'https://api.oneguard.net/api/';
  }

  public static get isLocalHost(): boolean {
    return window.location.hostname === 'localhost';
  }

  public static get isCustomerApp(): boolean {
    const nav: any = navigator;

    return nav.camera != null;
  }

  public static newid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  public static isCreditCardNumberValid(creditCardNumber) {
    let regex = new RegExp('^[0-9]{16}$');
    if (!regex.test(creditCardNumber)) {
      regex = new RegExp('^[0-9]{15}$');
      if (!regex.test(creditCardNumber)) {
        return false;
      }
    }

    const lunCheckResult = UtilitiesService.luhnCheck(creditCardNumber);

    return lunCheckResult;
  }

  public static isEmailValid(emailToTest: string): boolean {
    const re =
        /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

    return re.test(String(emailToTest).toLowerCase());
  }

  public static isValidPhoneNumber(phoneNumberToTest: string): boolean {
    const re = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;

    return re.test(String(phoneNumberToTest).toLowerCase());
  }

  private static luhnCheck(val) {
    // let sum = 0;
    // for (let i = 0; i < val.length; i++) {
    //   let intVal = parseInt(val.substr(i, 1), 10);
    //   if (i % 2 === 0) {
    //     intVal *= 2;
    //     if (intVal > 9) {
    //       intVal = 1 + (intVal % 10);
    //     }
    //   }
    //   sum += intVal;
    // }
    // return (sum % 10) === 0;

    // accept only digits, dashes or spaces
    if (/[^0-9-\s]+/.test(val)) return false;

    // The Luhn Algorithm. It's so pretty.
    var nCheck = 0, nDigit = 0, bEven = false;
    const value = val.replace(/\D/g, '');

    for (let n = val.length - 1; n >= 0; n--) {
      var cDigit = val.charAt(n), nDigit = parseInt(cDigit, 10);

      if (bEven) {
        if ((nDigit *= 2) > 9) nDigit -= 9;
      }

      nCheck += nDigit;
      bEven = !bEven;
    }

    return (nCheck % 10) == 0;
  }

  public static setupDocumentForAnimation() {
    $.fn.visible = function(partial) {

      var $t = $(this), $w = $(window), viewTop = $w.scrollTop(),
          viewBottom = viewTop + $w.height(), _top = $t.offset().top,
          _bottom = _top + $t.height(),
          compareTop = partial === true ? _bottom : _top,
          compareBottom = partial === true ? _top : _bottom;

      return ((compareBottom <= viewBottom) && (compareTop >= viewTop));

    };

    var win = $(window);

    var allMods = $(".animated");

    allMods.each(function(i, el) {
      var el = $(el);
      if (el.visible(true)) {
        el.addClass("already-visible");
      }
    });

    win.scroll(function(event) {
      var allMods = $(".animated");
      allMods.each(function(i, el) {
        var el = $(el);
        if (el.visible(true)) {
          el.addClass("come-in");
        }
      });

    });
  }

  constructor() {}
}
